"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSection = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const unavailability_context_1 = require("../unavailability-context");
const use_available_unav_sections_1 = require("../util/use-available-unav-sections");
const hasSection = (t) => (0, util_1.isValue)(t.section);
const ModalSection = ({ id, children, headerContent, init, cleanup, }) => {
    const sections = (0, use_available_unav_sections_1.useAvailableUnavSections)();
    const { toggledSections, addSectionListener, removeSectionListener } = (0, unavailability_context_1.useUnavailability)();
    // sections have to be indexed in order in which they are defined in sidebar
    // because of that we have to map toggled ids into their {sections and defined indexes} and sort based on indexes
    const sortedToggledSections = toggledSections
        .map((secId) => ({
        index: sections.findIndex((sec) => sec.id === secId),
        section: sections.find((sec) => sec.id === secId),
    }))
        .filter(hasSection)
        .sort((a, b) => a.index - b.index);
    react_1.default.useEffect(() => {
        if ((0, util_1.isDefined)(init)) {
            addSectionListener(id, 'on', init);
        }
        if ((0, util_1.isDefined)(cleanup)) {
            addSectionListener(id, 'off', cleanup);
        }
        return () => {
            if ((0, util_1.isDefined)(init)) {
                removeSectionListener('on', init);
            }
            if ((0, util_1.isDefined)(cleanup)) {
                removeSectionListener('off', cleanup);
            }
        };
    }, [addSectionListener, removeSectionListener, init, cleanup, id]);
    if (!toggledSections.includes(id)) {
        return null;
    }
    const sectionIndex = sortedToggledSections.findIndex((sec) => sec.section.id === id) + 1;
    const section = sortedToggledSections.find((sec) => sec.section.id === id)?.section;
    if ((0, util_1.isUndefined)(section)) {
        throw new Error('section cannot be undefined');
    }
    return (react_1.default.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexFlow: 'column' } },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'start',
                    marginBottom: '0.725rem',
                } },
                react_1.default.createElement("div", { style: {
                        width: '0.8rem',
                        height: '0.8rem',
                        borderRadius: '100%',
                        backgroundColor: '#0045ff',
                        fontSize: '0.45rem',
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingLeft: 1,
                    } }, sectionIndex),
                react_1.default.createElement(ui_1.Text, { weight: 'bold', type: 'body-large' },
                    section.name,
                    ":")),
            headerContent),
        children));
};
exports.ModalSection = ModalSection;
